export default __webpack_public_path__ + "static/media/mon_256.36c5ae12.png";